
define('modules/application/wizard/classes/kit',["app",

// Libs
"backbone",

//Classes
"./genericElement",

//Plugins
"plugins/jquery-dotdotdot"],

function(app, Backbone, genericElement) {

  var kitModel = Backbone.Model.extend({

  });

  var kits    = _.extend({}, genericElement, {

    View: Backbone.View.extend({
      tagName: "section",
      className: "singleKit",
      //template: "application/kit",
      events: {
        // "click a": "openSystemWindow",
        'click .referencesKit': 'controlSelectedInput'
      },
      
      serialize: function(){
        return{model:this.model, app:app};
      },

      initialize: function(){
        //this.setTemplate('single');
      },

      setTemplate: function(typeView){
        if (typeView == 'single') {
          // s4b solution - every kit has only one accessoryline
          this.template = "application/kit";
        }
        else if (typeView == 'multi') {
          // single webapp - every kit has many accessoryline
          this.template = "application/kitMultiAccessoryLine";
        }
        else {
          this.template = "application/kit";
        }
      },

      controlSelectedInput: function(el){
        el.parent.find("checkbox").each(function(){
          $(this).removeAttr("checked");
        });
        el.addAttr("checked","checked");
      }
      
    }),

    Model : Backbone.Model.extend({

    })
  });

  // Required, return the module for AMD compliance
  return kits;
});